import { MetaList } from 'features/knowledgeDocumentViewer/components/metadata/metadataFieldListStyles'
import { MetadataFieldRow } from 'features/knowledgeDocumentViewer/components/metadata/MetadataFieldRow'
import type { PageMetadataFieldLabel } from 'features/knowledgeDocumentViewer/utils/pageMetadataFieldKeys'
import type { MetadataDisplayField } from 'features/knowledgeDocumentViewer/utils/pageMetadataFields'
import React from 'react'

export type MetadataFieldValueControl = {
  label: PageMetadataFieldLabel
  node: React.ReactNode
}

export type MetadataFieldListProps = {
  fields: readonly MetadataDisplayField[]
  valueControl?: MetadataFieldValueControl
}

export function MetadataFieldList({
  fields,
  valueControl,
}: MetadataFieldListProps): React.ReactElement | null {
  if (fields.length === 0) return null

  return (
    <MetaList>
      {fields.map(({ label, value }) => (
        <MetadataFieldRow
          key={label}
          label={label}
          value={value}
          valueControl={
            valueControl?.label === label ? valueControl.node : undefined
          }
        />
      ))}
    </MetaList>
  )
}
